import React, { useContext, useMemo } from 'react';

import DashboardGadgetsContext from '../../../contexts/DashboardGadgetsContext';
import VisualisationCacheContext from '../../../contexts/VisualisationCacheContext';

const DashboardGadgetsProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => {
  const { cache } = useContext(VisualisationCacheContext);

  const allGadgets = useMemo(
    () => Array.from(cache.dashboardGadgets.values()),
    [cache],
  );

  const dashboardGadgetsLookup = useMemo(() => {
    const lookup: { [id: string]: DashboardGadget | undefined } = {};
    allGadgets.forEach((g) => {
      lookup[g.id] = g;
    });
    return lookup;
  }, [allGadgets]);

  return (
    <DashboardGadgetsContext.Provider
      value={{
        allGadgets,
        isLoading: false,
        dashboardGadgetsLookup,
      }}
    >
      {children}
    </DashboardGadgetsContext.Provider>
  );
};

export default DashboardGadgetsProvider;
